// @core/api/endpoints/userprofile/set_privacy_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetPrivacySettingsRequest,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Set privacy settings for profile
 * Updates privacy settings controlling who can view the profile and interact with the user. Changes affect visibility immediately.
 */
export async function SetPrivacySettings(
  profile_id: string,
  data: SetPrivacySettingsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/settings/privacy`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
